import {
  types,
  IPublishedSearch,
  PublishedSearchActionsType,
} from '../types/publishedSearch'

export const initialState: IPublishedSearch = {
  isLoading: false,
  items: [],
  totalCount: 0,
  skip: 0,
}

export const publishedSearch = (
  state = initialState,
  action: PublishedSearchActionsType
): IPublishedSearch => {
  switch (action.type) {
    case types.PUBLISHED_SEARCH_PACKS__STARTED:
      return { ...state, isLoading: true }
    case types.PUBLISHED_SEARCH_PACKS__SUCCESS:
      return {
        ...state,
        isLoading: false,
        items: [...state.items, ...action.items],
        totalCount: action.totalCount,
      }
    case types.PUBLISHED_SEARCH_PACKS__FAILURE:
      return { ...state, isLoading: false }
    case types.UPDATE_PUBLISHED_SKIP_QUERY:
      return { ...state, skip: action.skip }
    case types.RESET_PUBLISHED_SEARCH:
      return initialState
    default:
      return state
  }
}
